export default {
    goodsPage: {
        dPs1: '温馨提示',
        dPs2: '为方便仓库顺利入库，请您：',
        dPs3: '1 按照PO页面上的商品数量进行打包；',
        dPs4: '2 将PO页面打印出来，并放置在托盘覆盖膜内，方便同事快速核对。',
        dPs5: '感谢您的配合！',
        dPs6: '确认并下载PO页面',
        review: '批量审核',
        ERROR: '错误',
        SUCCESS: '导入成功',
        FAILED: '导入失败',
        rejection: '批量驳回',
        skuName: 'SKU名称',
        skuCode: 'SKU编码',
        num: '搭配数量',
        spuName: '商品名称',
        spuCode: 'SPU编码',
        itemType: '产品类型',
        uomGroup: 'UOM Group',
        asignBarcode: '是否使用系统条形码',
        barCode: '条形码',
        skuDesc: '描述',
        qty: '每箱件数',
        fragile: '是否酒水',
        needExpired: '批次和过期日期',
        Serial: '序列号',
        vendorName: '供应商',
        buyingDepName: '采购部门',
        buyerName: '采购员',
        cartonBoxBarcode: '外包装条形码',
        seasonable: '季节性产品',
        merchandiser: 'ebay跟单员',
        merchandiser2: 'amz跟单员',
        discontinued: '是否继续在售',
        rmb: 'RMB',
        inventoryItem: '库存产品',
        purchaseItem: '进货物品',
        salesItem: '销售物品',
        dangerousGoods: '危险品',
        flammable: '易燃',
        imageUrl: '图片',
        Dimensional: '尺寸校验',
        auditIdea: '审核意见',
        need: '批次和过期日期',
        packingM: '打包方式',
        packingT: '包裹类型',

        categoryName: '商品分类',
        brandName: '商品品牌',
        // material: '素材',

        productTypes: '商品类型',
        packageProduct: '新增组合商品',
        generalMerchandise: '新增普通商品',
        brandNameTable: '品牌名称',
        // materialNameText: '素材名称',
        confirm1: '您正在所选的数据提交审核，是否继续？',
        msgWarning: 'TODO:接口  SP001商品信息未完整，请完善商品信息',

        // materialName: '素材名称',
        MainImage: '主图',
        DetailMap: '详情图',
        description: '商品描述',
        itemPerCarton: 'Item Per Carton',
        costPrice: '成本价',
        salesPrice: '销售价',
        Predicted: '是否预测',
        prediction: '已预测',
        Not: '未预测',
        Actual: '实际利润率',
        Standard: '标准利润率',
        rate: '重发/补发率',

        weight: '商品重量',
        length: '商品长度',
        width: '商品宽度',
        height: '商品高度',
        volume: '商品体积',
        rule: '规则',
        ps1: '缺少必填字段。',
        ps4: '【成本价】格式错误。',
        ps5: '【每箱单位】格式错误',
        ps6_1: '【单位长度】格式错误',
        ps6_2: '【单位宽度】格式错误',
        ps6_3: '【单位高度】格式错误',
        ps6_4: '【单位重量】格式错误',
        ps7_1: '【外箱长度】格式错误',
        ps7_2: '【外箱宽度】格式错误',
        ps7_3: '【外箱高度】格式错误',
        ps7_4: '【外箱重量】格式错误',
        ps8: '单位长度应小于外箱长度',
        ps9: '单位宽度应小于外箱宽度',
        ps10: '单位高度应小于外箱高度',
        ps11: '单品重量 * 每箱件数 应小于 外箱重量',
        ps12: 'sku中不允许有空格',
        ps121: 'sales kit sku中不允许有空格',
        ps13: '内含有公式计算，不符合数据格式，请改为手动输入!',
        rule1: '1、必填项：SKU名称、SKU编码、商品类型、单品长度，单品宽度，单品高度，单品重量',
        rule2: '2、SKU编码允许连字符和下划线，但不允许空格和其他特殊字符',
        rule3: '3、批次和过期日期必须为是或者否',
        rule13: '13、序列号必须为是或者否',
        rule4: '4、成本价可以为空，为空时，默认为0；成本价不为空时，须为非负数，最多2位小数',
        rule5: '5、每箱件数可以为空，为空时默认为1；每箱件数不为空时，须为正整数',
        rule6: '6、单品长度，单品宽度，单品高度，单品重量为正数，最多2位小数',
        rule7: '7、当每箱件数 > 1时，外箱长度，外箱宽度，外箱高度，外箱重量必填，为正数，最多2位小数',
        rule8: '8、单品长度 ≤ 外箱长度',
        rule9: '9、单品宽度 ≤ 外箱宽度',
        rule10: '10、单品高度 ≤ 外箱高度',
        // rule11: '11、单品体积*每箱件数 ≤ 外箱体积',
        rule11: '11、单品重量*每箱件数 ≤ 外箱重量',
        rule12: '12、Barcode需小于等于14位，且不允许空格和其他特殊字符',
        barcodeRule: 'barcode不能以空格开头或结尾',
        package:{
            Name: '包材名称',
            SKU:'包材SKU',
            Barcode: '包材条码',
            Method: '打包方式',
            Type: '包材分类',
            Supplier: '供应商',
            Cost: '包材成本',
            Price: '包材售价',
            fee: '打包费',
            Length: '长(CM)',
            Width: '宽(CM)',
            Height: '高(CM)',
            Weight: '重(KG)',
            order: '订单包材',
            product: '产品包材',
            csg: 'csg包材',
            cus: '客户包材',
            Info:'包材信息',
            edit:'包材编辑',
            Selectpackagingmaterials: '选择包材',
            num: '包材数量',
            money1: '材料费(AUD)',
            money2: '人工费(AUD)',
            bindSKU: '绑定商品',
            bindInfo: '绑定信息',
        },
    }
};
